module.exports = __webpack_public_path__ + "img/zyjy_02.2e715aa9.png";